export const STORAGE_KEYS = {
  skipLogoutConfirm: "skip-logout-confirm",
} as const;
